(() => {
  if (window.KDKFrameInfoGallery && typeof window.KDKFrameInfoGallery.init === 'function') {
    window.KDKFrameInfoGallery.init(document);
    return;
  }

  const instances = new Map();

  function keyFromValue(value) {
  return String(value || '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/\u00A0/g, ' ')
    .replace(/&/g, '_')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}


  function canonicalFrameKeys(value) {
    const raw = keyFromValue(value);
    const tokens = raw.split('_').filter(Boolean);
    const has = (values) => values.some((item) => tokens.includes(item));

    let family = '';
    if (has(['minimal'])) family = 'minimal';
    else if (has(['century'])) family = 'century';
    else if (has(['gallery', 'galery', 'galeri', 'lienzo'])) family = 'gallery';

    let color = '';
    if (has(['negro', 'black', 'noir', 'schwarz', 'preto'])) color = 'negro';
    else if (has(['blanco', 'white', 'blanc', 'weiss', 'wei', 'branco'])) color = 'blanco';
    else if (has(['nogal', 'walnut', 'noyer', 'walnuss', 'nogueira'])) color = 'nogal';
    else if (has(['madera', 'roble', 'wood', 'oak', 'bois', 'chene', 'eiche', 'holz', 'madeira', 'carvalho'])) color = 'roble';

    const keys = [raw];
    if (family === 'minimal' && ((has(['black', 'negro', 'noir', 'schwarz', 'preto']) && has(['white', 'blanco', 'blanc', 'weiss', 'wei', 'branco'])) || raw.endsWith('_b_n'))) {
      keys.push('minimal_marco_b_n');
    } else if (family === 'gallery' && has(['sin', 'sans', 'ohne', 'sem', 'unframed'])) {
      keys.push('lienzo_sin_marco');
    } else if (family && color) {
      keys.push(`${family}_marco_${color}`);
      if (color === 'roble') keys.push(`${family}_marco_madera`);
    }
    return [...new Set(keys.filter(Boolean))];
  }

  function parseJson(root) {
    const source = root.querySelector('[data-kdk-frame-info-data]');
    if (!source) return [];

    try {
      const payload = JSON.parse(source.textContent || '[]');
      return Array.isArray(payload) ? payload : [];
    } catch (error) {
      console.error('[KDK frame info] JSON inválido', error);
      return [];
    }
  }

  class FrameInfoGallery {
    constructor(root) {
      this.root = root;
      this.formRoot = root.closest('.ProductForm__Variants') || document;
      this.infoBox = root.querySelector('[data-kdk-frame-info]');
      this.heading = root.querySelector('[data-kdk-frame-heading-text]');
      this.thumbList = root.querySelector('[data-kdk-frame-thumb-list]');
      this.modal = root.querySelector('[data-kdk-frame-modal]');
      this.closeButton = root.querySelector('[data-kdk-frame-modal-close]');
      this.slideList = root.querySelector('[data-kdk-frame-slide-list]');
      this.modalThumbList = root.querySelector('[data-kdk-frame-modal-thumb-list]');
      this.title = root.querySelector('[data-kdk-frame-title]');
      this.finish = root.querySelector('[data-kdk-frame-finish]');
      this.swatch = root.querySelector('[data-kdk-frame-swatch]');
      this.intro = root.querySelector('[data-kdk-frame-intro]');
      this.features = root.querySelector('[data-kdk-frame-features]');
      this.counter = root.querySelector('[data-kdk-frame-counter]');
      this.labels = JSON.parse(root.querySelector('[data-kdk-frame-labels]').textContent);
      this.prevButton = root.querySelector('[data-kdk-frame-prev]');
      this.nextButton = root.querySelector('[data-kdk-frame-next]');
      this.items = parseJson(root)
        .map((item) => ({
          ...item,
          __key: keyFromValue(item.key),
          __aliases: Array.isArray(item.aliases)
            ? item.aliases.map(keyFromValue).filter(Boolean)
            : [],
          images: Array.isArray(item.images)
            ? item.images.filter((image) => image && (image.full || image.thumb))
            : []
        }))
        .filter((item) => item.__key && item.images.length);
      this.map = new Map();
      this.items.forEach((item) => {
        [item.__key, ...item.__aliases].forEach((key) => {
          if (key) this.map.set(key, item);
        });
      });
      this.currentItem = null;
      this.currentSlide = 0;
      this.boundChange = this.onChange.bind(this);
      this.boundKeydown = this.onKeydown.bind(this);
      this.events = new AbortController();

      if (!this.infoBox || !this.modal || !this.items.length) {
        this.hideInfo();
        return;
      }

      window.KDKProductDialogs.close(this.modal);
      this.bindEvents();
      this.syncFromForm();
    }

    bindEvents() {
      const options = { signal: this.events.signal };
      this.formRoot.addEventListener('change', this.boundChange, options);
      this.closeButton?.addEventListener('click', () => this.closeModal(), options);
      this.prevButton?.addEventListener('click', () => this.showSlide(this.currentSlide - 1), options);
      this.nextButton?.addEventListener('click', () => this.showSlide(this.currentSlide + 1), options);
      this.modal.addEventListener('keydown', this.boundKeydown, options);
    }

    destroy() {
      this.closeModal();
      this.events.abort();
    }

    onChange(event) {
      const input = event.target.closest('input[type="radio"][data-option-position="1"]');
      if (!input) return;
      this.render(input.value);
    }

    onKeydown(event) {
      if (!this.modal.open) return;

      if (event.key === 'Escape') {
        this.closeModal();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.showSlide(this.currentSlide - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.showSlide(this.currentSlide + 1);
      }
    }

    syncFromForm() {
      const checked = this.formRoot.querySelector('input[type="radio"][data-option-position="1"]:checked');
      if (checked) {
        this.render(checked.value);
      } else {
        this.hideInfo();
      }
    }

    hideInfo() {
      if (this.infoBox) {
        this.infoBox.style.display = 'none';
        this.infoBox.hidden = true;
      }
    }

    render(frameValue) {
      const item = canonicalFrameKeys(frameValue)
        .map((key) => this.map.get(key))
        .find(Boolean);
      this.currentItem = item || null;

      if (!item) {
        this.hideInfo();
        this.closeModal();
        return;
      }

      const family = this.labels.families[item.family];
      const name = `${family.title} · ${this.labels.finishes[item.finish]}`;
      this.heading.textContent = this.labels.detailHeading.replace('__name__', name);
      this.thumbList.replaceChildren();

      item.images.forEach((image, index) => {
        const column = document.createElement('div');
        column.className = 'column';

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kdk-frame-trigger';
        button.setAttribute('aria-label', `${this.heading.textContent}. ${this.imageLabel(index)}`);
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', this.modal.id);
        button.addEventListener('click', () => this.openModal(index));

        const img = document.createElement('img');
        img.src = image.thumb || image.full || '';
        img.alt = '';
        img.width = image.width;
        img.height = image.height;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.style.width = '100%';
        img.className = 'hover-shadow cursor-2';
        button.appendChild(img);
        column.appendChild(button);
        this.thumbList.appendChild(column);
      });

      this.infoBox.hidden = false;
      this.infoBox.style.display = 'block';
    }

    buildModal() {
      if (!this.currentItem) return;

      const item = this.currentItem;
      const family = this.labels.families[item.family];
      this.title.textContent = family.title;
      this.finish.textContent = this.labels.finishes[item.finish];
      this.swatch.dataset.finish = item.finish;
      this.intro.textContent = family.intro;
      this.features.replaceChildren(...family.features.map((text) => {
        const feature = document.createElement('li');
        feature.textContent = text;
        return feature;
      }));
      this.modalThumbList.replaceChildren();
      this.image = document.createElement('img');
      this.image.className = 'kdk-frame-image';
      this.image.decoding = 'async';
      this.slideList.replaceChildren(this.image);
      this.prevButton.hidden = this.nextButton.hidden = item.images.length < 2;

      item.images.forEach((image, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kdk-frame-thumbnail';
        button.setAttribute('aria-label', this.imageLabel(index));
        button.addEventListener('click', () => this.showSlide(index));

        const thumb = document.createElement('img');
        thumb.src = image.thumb || image.full || '';
        thumb.alt = '';
        thumb.width = image.width;
        thumb.height = image.height;
        thumb.loading = 'lazy';
        thumb.decoding = 'async';
        button.appendChild(thumb);
        this.modalThumbList.appendChild(button);
      });
    }

    openModal(index) {
      if (!this.currentItem) return;
      if (this.builtItem !== this.currentItem) {
        this.buildModal();
        this.builtItem = this.currentItem;
      }
      this.showSlide(index);
      window.KDKProductDialogs.open(this.modal);
    }

    closeModal() {
      window.KDKProductDialogs.close(this.modal);
    }

    showSlide(index) {
      if (!this.currentItem || !this.image) return;
      const images = this.currentItem.images;
      index = (index + images.length) % images.length;
      this.currentSlide = index;
      const image = images[index];
      this.image.width = image.width;
      this.image.height = image.height;
      this.image.alt = `${this.title.textContent} · ${this.finish.textContent}. ${this.imageLabel(index, 'counter')}`;
      this.image.src = image.full || image.thumb;
      this.counter.textContent = this.imageLabel(index, 'counter');
      Array.from(this.modalThumbList.children).forEach((thumb, thumbIndex) => {
        thumb.setAttribute('aria-pressed', String(thumbIndex === index));
      });
    }

    imageLabel(index, key = 'viewImage') {
      return this.labels[key]
        .replace('__current__', index + 1)
        .replace('__total__', this.currentItem.images.length);
    }
  }

  function getRoots(scope) {
    if (!scope) return [];
    if (scope.matches?.('[data-kdk-frame-info-gallery]')) return [scope];
    return Array.from(scope.querySelectorAll?.('[data-kdk-frame-info-gallery]') || []);
  }

  function init(scope = document) {
    getRoots(scope).forEach((root) => {
      const key = root.id || root.dataset.kdkFrameInfoGallery || `kdk-frame-${instances.size + 1}`;
      const existing = instances.get(key);
      if (existing) existing.destroy();
      instances.set(key, new FrameInfoGallery(root));
    });
  }

  function destroy(scope = document) {
    getRoots(scope).forEach((root) => {
      const key = root.id || root.dataset.kdkFrameInfoGallery;
      const instance = instances.get(key);
      if (!instance) return;
      instance.destroy();
      instances.delete(key);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));

  window.KDKFrameInfoGallery = {
    init,
    destroy,
    instances
  };
})();

